import { baseQuery } from '../baseQuery';

export const getHearAboutUs = async () => {
  const data = await baseQuery('hear-about-us');

  return data;
};
